/* Constants */

export default {
	langs: [
		{ key: 'de', text: 'DE', textLong: 'Deutsch' },
		{ key: 'en', text: 'EN', textLong: 'English' },
		{ key: 'en_us', text: 'US', textLong: 'English (US)' },
		{ key: 'es', text: 'ES', textLong: 'Español' },
		{ key: 'fr', text: 'FR', textLong: 'Français' },
		{ key: 'it', text: 'IT', textLong: 'Italiano' },
		{ key: 'nl', text: 'NL', textLong: 'Nederlands' },
	],

	specifications: {
		projects: ['4', '65', '66'],
		/* ... */
	},

	max_chars: {
		'setup.objectname': 100,
		'objectdata.metaTitle': 70,
		'objectdata.metaDescription': [140, 150],
	},

	NOTPLANNEDDATE: '2030-01-01 00:00:00',
	CLEARDATE: '0000-00-00 00:00:00',

	NO_CONTENT: '[no_content]',
	DATETIMEFORMAT: 'YYYY-MM-DD HH:mm:ss',
	DATETIMEFORMATDEST: 'DD.MM.YYYY HH:mm',
	DATEFORMATDEST: 'DD.MM.YYYY',
};



// WEBPACK FOOTER //
// ./src/constants.js